import { render, staticRenderFns } from "./StaffDashboardView.vue?vue&type=template&id=befc809e&scoped=true"
import script from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDashboardView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./StaffDashboardView.vue?vue&type=style&index=0&id=befc809e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc809e",
  null
  
)

export default component.exports